import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ContactUsButton: React.FC<{ 
  className?: string; 
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({ className = '', children, onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // Call the custom onClick if provided
    if (onClick) {
      onClick(e);
    } else {
      // Default navigation behavior
      navigate('/service');
    }
  };
  
  return (
    <button
      onClick={handleClick}
      className={`px-4 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition ${className}`}
      type="button"
    >
      {children || t('contact.talkToUs')}
    </button>
  );
};

export default ContactUsButton; 